// import { Icon } from '@iconify/react/dist/iconify.js';
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// function Profile() {
//     const [imagePreview, setImagePreview] = useState('assets/images/profileimg.webp');

//     const handleImageChange = (event) => {
//         const file = event.target.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onload = () => {
//                 setImagePreview(reader.result);
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     return (
//         <div>
//             <div className="my-3">
//                 <h6 className="fw-semibold mb-0 ms-3">My Profile</h6>
//             </div>
//             <div className="col-lg-12">
//                 <div className="card h-100">
//                     <div className="card-body p-24">
//                         <div className="tab-content" id="pills-tabContent">
//                             <div className="tab-pane fade show active" id="pills-edit-profile">
//                                 <h6 className="text-md text-primary-light mb-16">Personal Details</h6>
//                                 <div className="mb-24 mt-16">
//                                     <div className="avatar-upload">
//                                         <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
//                                             <input
//                                                 type="file"
//                                                 id="imageUpload"
//                                                 accept=".png, .jpg, .jpeg"
//                                                 hidden
//                                                 onChange={handleImageChange}
//                                             />
//                                             <label
//                                                 htmlFor="imageUpload"
//                                                 className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-dark text-primary-600 border border-primary-600  text-lg rounded-circle"
//                                             >
//                                                 <Icon icon="solar:camera-outline" className="icon text-white" />
//                                             </label>
//                                         </div>
//                                         <div className="avatar-preview">
//                                             <div
//                                                 style={{
//                                                     backgroundImage: `url(${imagePreview})`,
//                                                     backgroundSize: 'cover',
//                                                     backgroundPosition: 'center',
//                                                     width: '150px',
//                                                     height: '150px',
//                                                     borderRadius: '50%'
//                                                 }}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <form action="#">
//                                     <div className="row">
//                                         <div className="col-sm-4">
//                                             <div className="mb-20">
//                                                 <label
//                                                     htmlFor="name"
//                                                     className="form-label fw-semibold text-primary-light text-sm mb-8" >
//                                                     User Name
//                                                 </label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control radius-8"
//                                                     id="name"
//                                                     placeholder="kapl"
//                                                     readOnly
//                                                     disabled
//                                                 />
//                                             </div>
//                                         </div>
//                                         <div className="col-sm-4">
//                                             <div className="mb-20">
//                                                 <label
//                                                     htmlFor="email"
//                                                     className="form-label fw-semibold text-primary-light text-sm mb-8"
//                                                 >
//                                                     Email
//                                                 </label>
//                                                 <input
//                                                     type="email"
//                                                     className="form-control radius-8"
//                                                     id="email"
//                                                     placeholder="Enter email address"
//                                                     value="info@kapl.com"
//                                                     readOnly
//                                                     disabled
//                                                 />
//                                             </div>
//                                         </div>
//                                         <div className="col-sm-4">
//                                             <div className="mb-20">
//                                                 <label
//                                                     htmlFor="number"
//                                                     className="form-label fw-semibold text-primary-light text-sm mb-8" >
//                                                     Contact Number
//                                                 </label>
//                                                 <input
//                                                     type="email"
//                                                     className="form-control radius-8"
//                                                     id="number"
//                                                     placeholder="Enter phone number"
//                                                     value="+91 6365961111"
//                                                     readOnly
//                                                     disabled
//                                                 />
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="d-flex align-items-center justify-content-end gap-3">
//                                         <button
//                                             type="button"
//                                             className="btn bg-dark text-white border border-primary-600 text-md px-56 py-12 radius-8">
//                                             Save
//                                         </button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default Profile;



import { Icon } from '@iconify/react/dist/iconify.js';
import { useState, useEffect } from 'react';
import { api } from '../helper/api.interceptor';
import Swal from 'sweetalert2';


function Profile() {
    const [imagePreview, setImagePreview] = useState('assets/images/profileimg.webp');
    const [profileData, setProfileData] = useState({
        username: '',
        email: '',
        contact: '',
        profileImage: '',
        confirmPassoword: "",
        password: ""
    });
    const [loading, setLoading] = useState(true);
    const handleUpdateProfilePic = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const blobUrl = URL.createObjectURL(file);
        console.log('blobUrl: ', blobUrl);

        setProfileData((prev) => ({
            ...prev,
            profileImage: file,
        }));
        setImagePreview(blobUrl);
    };


    const fetchProfileData = async () => {
        try {
            const data = await api.myprofile();
            if (data) {
                setProfileData({
                    username: data.username,
                    email: data.email,
                    contact: data.contact,
                    profileImage: data.profileImage
                        ? `${process.env.REACT_APP_UPLOAD_PATH}${data.profileImage}`
                        : 'assets/images/profileimg.webp'
                });
                setImagePreview(data.profileImage
                    ? `${process.env.REACT_APP_UPLOAD_PATH}${data.profileImage}`
                    : 'assets/images/profileimg.webp');
            }
        } catch (error) {
            console.error("Error fetching profile data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchProfileData();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setProfileData(prev => {
            console.log('prev: ', prev);
            return ({
                ...prev,
                [name]: value
            })
        });
    };




    const [isEditing, setIsEditing] = useState(false);

    // Handle profile update submission
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        // Check if user tried to update password
        const password = profileData.password?.trim();
        const confirmPassword = profileData.confirmPassoword?.trim();

        // Only validate password if either field is filled
        if ((password || confirmPassword) && password !== confirmPassword) {
            Swal.fire({
                icon: 'error',
                text: 'Passwords do not match',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
            return;
        }

        try {
            const formData = {};
            formData['username'] = profileData.username
            formData['email'] = profileData.email
            formData['contact'] = profileData.contact;

            if ((typeof profileData.profileImage !== "string" && Boolean(profileData.profileImage)) || profileData.profileImage instanceof File) {
                formData['profileImage'] = profileData.profileImage; // actual file
            }
            if (profileData.password !== "" && profileData.password === profileData.confirmPassoword) {
                formData['password'] = profileData.password; // actual password
            }


            const updatedProfile = await api.updateMyProfile(formData);

            const updatedImageUrl = updatedProfile.profileImage
                ? `${updatedProfile.profileImage}`
                : 'assets/images/profileimg.webp';

            setProfileData((prev) => ({
                ...prev,
                username: updatedProfile.username,
                email: updatedProfile.email,
                contact: updatedProfile.contact,
                profileImage: updatedImageUrl
            }));

            setImagePreview(updatedImageUrl);
            setIsEditing(false);
            Swal.fire({
                icon: 'success',
                text: 'Profile updated successfully!',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        } catch (error) {
            console.error('Failed to update profile:', error);
            Swal.fire({
                icon: 'error',
                text: 'Failed to update profile. Please try again.',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        }
    };
    return (
        <div>
            <div className="my-3">
                <h6 className="fw-semibold mb-0 ms-3">My Profile</h6>
            </div>
            <div className="col-lg-12">
                <div className="card h-100">
                    <div className="card-body p-24">
                        <div className="tab-content" id="pills-tabContent">
                            <div className="tab-pane fade show active" id="pills-edit-profile">
                                <h6 className="text-md text-primary-light mb-16">Personal Details</h6>
                                <div className="mb-24 mt-16">
                                    <div className="avatar-upload">
                                        <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                                            <input
                                                type="file"
                                                id="imageUpload"
                                                accept=".png, .jpg, .jpeg"
                                                hidden
                                                onChange={handleUpdateProfilePic}
                                            />
                                            <label
                                                htmlFor="imageUpload"
                                                className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-dark text-primary-600 border border-primary-600  text-lg rounded-circle"
                                            >
                                                <Icon icon="solar:camera-outline" className="icon text-white" />
                                            </label>
                                        </div>
                                        <div className="avatar-preview">
                                            <div
                                                style={{
                                                    backgroundImage: `url(${imagePreview})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center',
                                                    width: '150px',
                                                    height: '150px',
                                                    borderRadius: '50%'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <form action="#">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="name"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8" >
                                                    User Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control radius-8"
                                                    id="name"
                                                    name="username"
                                                    placeholder="Username"
                                                    value={profileData.username}
                                                    onChange={handleInputChange}
                                                // readOnly
                                                // disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="email"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                >
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control radius-8"
                                                    id="email"
                                                    placeholder="Enter email address"
                                                    name="email"
                                                    value={profileData.email}
                                                    onChange={handleInputChange}
                                                // readOnly
                                                // disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="number"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8" >
                                                    Contact Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control radius-8"
                                                    id="number"
                                                    placeholder="Enter phone number"
                                                    name="contact"
                                                    value={profileData.contact}
                                                    onChange={handleInputChange}
                                                // readOnly
                                                // disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="name"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8" >
                                                    Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control radius-8"
                                                    name="password"
                                                    placeholder="Password"
                                                    value={profileData.password}
                                                    onChange={handleInputChange}
                                                // readOnly
                                                // disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="name"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8" >
                                                    Confirm Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control radius-8"
                                                    name="confirmPassoword"
                                                    placeholder="Confirm Passoword"
                                                    value={profileData.confirmPassoword}
                                                    onChange={handleInputChange}
                                                // readOnly
                                                // disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end gap-3">
                                        <button
                                            onClick={handleUpdateProfile}
                                            type="button"
                                            className="btn bg-dark text-white border border-primary-600 text-md px-56 py-12 radius-8">
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Profile;